import React from 'react';
import PropTypes from 'prop-types';
import SearchTeaser from 'components/search-teaser/search-teaser';
import LoadingIndicator from 'components/loading-indicator';
import ErrorMessage from 'components/error-message';
import LoadMoreButton from 'components/load-more-button/load-more-button';
import TextSkeleton from 'components/text-skeleton';

const SearchSection = ({
  heading,
  hits,
  hasMore,
  loadMoreButtonText,
  onLoadMoreClick = () => {},
  isLoading,
  asSkeleton,
  isFirstSection,
  showError,
  errorMessage,
}) => {
  return (
    <div className="search-section">
      <div className="search-section__container">
        <div className="search-section__heading-holder">
          {asSkeleton ? (
            <TextSkeleton
              className="search-section__heading-skeleton"
              lineClassName="search-section__heading-skeleton-line"
              maxLines={1}
            />
          ) : heading ? (
            <h2 className="search-section__heading">{heading}</h2>
          ) : null}
        </div>
        {hits && (
          <ul className="search-section__items">
            {hits.map((teaser, index) => (
              <li key={index} className="search-section__item">
                <SearchTeaser
                  {...teaser}
                  asSkeleton={asSkeleton}
                  preloadImage={isFirstSection && index === 0}
                  className="search-section__teaser"
                />
              </li>
            ))}
          </ul>
        )}
        {asSkeleton ? (
          <LoadMoreButton
            asSkeleton={true}
            text={loadMoreButtonText}
            className="search-section__load-more-btn"
          />
        ) : (
          hasMore && (
            <LoadMoreButton
              text={loadMoreButtonText}
              onClick={onLoadMoreClick}
              className="search-section__load-more-btn"
            />
          )
        )}
        {isLoading && <LoadingIndicator />}
        {showError && <ErrorMessage text={errorMessage} />}
      </div>
    </div>
  );
};

SearchSection.propTypes = {
  errorMessage: PropTypes.string,
  pageType: PropTypes.string,
  heading: PropTypes.string,
  hits: PropTypes.arrayOf(PropTypes.exact(SearchTeaser.propTypes)),
  hasMore: PropTypes.bool,
  onLoadMoreClick: PropTypes.func,
  loadMoreButtonText: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  asSkeleton: PropTypes.bool,
  isFirstSection: PropTypes.bool,
  showError: PropTypes.bool,
};

SearchSection.viewModelMeta = {
  loadMoreButtonText: 'ignore',
  isLoading: 'ignore',
  asSkeleton: 'ignore',
  isFirstSection: 'ignore',
  showError: 'ignore',
  errorMessage: 'ignore',
};

export default SearchSection;
